/*
 * Which path the form's "Send chat" takes, and how an API send failure is
 * handled. Only the API send resets the 20-min hold; the websocket send is the
 * fallback so a rep's message is never lost.
 */

import { CLAIM_MINE } from '../../util_components/instant_alert/claim';

export type ChatSendRoute = 'api' | 'socket';

export interface ChatSendTask {
  is_lead?: boolean;
  student_uuid?: string;
}

// The endpoint answers 409 for a non-holder and 400 for a lead task.
export const chat_send_route = (
  state: string | null | undefined,
  task: ChatSendTask | null | undefined
): ChatSendRoute =>
  state === CLAIM_MINE && !!task && !task.is_lead && !!task.student_uuid ? 'api' : 'socket';

export type ChatSendFailure = 'rejected' | 'not_holder' | 'terminal' | 'fallback';

interface HttpError {
  response?: { status?: number };
}

// 'fallback' covers 502 CHAT_PUBLISH_FAILED, other 5xx and no response: the
// server may not have published, so the socket send must run — with the same
// message id, so chat_server drops it if the API publish did land.
export const chat_send_failure = (e: unknown): ChatSendFailure => {
  const status = (e as HttpError | null | undefined)?.response?.status;
  if (status === 400) return 'rejected';
  if (status === 409) return 'not_holder';
  if (status === 410) return 'terminal';
  return 'fallback';
};
